import { coreActions } from '@sonar-software/sonar-core';
import { getRowKey } from '../';
import { PERISCOPE_TAB_TYPES } from '@sonar-software/sonar-ts-constants';
import { PeriscopeFieldRow } from './';
import { SelectionTable } from '@ui/tables';
import { PeriscopeSfField, SonarObjectType } from '@sonar-software/sonar-ts-types';
import React, { useCallback, useEffect } from 'react';
import { useAction, useApiResource, useSelectionTable } from '@hooks';

export interface SalesforceFieldSelectionTableProps {
	parentIndex: number;
	resourceIdsUri?: string;
	showParents?: boolean;
	uri: string;
}

export const SalesforceFieldSelectionTable: React.FC<SalesforceFieldSelectionTableProps> = ({
	parentIndex,
	resourceIdsUri,
	showParents,
	uri
}) => {
	const { resource, loading } = useApiResource<PeriscopeSfField[]>(uri);
	const selectionData = useSelectionTable({
		getRowKey,
		resourceIdsUri,
		results: resource,
		selectionType: SonarObjectType.SalesforceField
	});
	const updateReferences = useAction(coreActions.updateSonarObjectReferences);

	useEffect(() => {
		if (resource) {
			updateReferences(
				resource.map((result) => ({
					displayName: result.displayName,
					ingestedBy: result.ingestedBy,
					parentDisplayName: result.parentDisplayName,
					parentSonarObjectId: result.parentSonarObjectId,
					populatedBy: result.populatedBy,
					relatedCounts: result.relatedCounts,
					sonarObjectId: result.sonarObjectId,
					sonarObjectType: SonarObjectType.SalesforceField,
					tags: result.tagIds
				}))
			);
		}
	}, [ resource, updateReferences ]);

	const renderField = useCallback(
		(field: PeriscopeSfField) =>
			<PeriscopeFieldRow
				field={ field }
				key={ field.sonarObjectId }
				parentIndex={ parentIndex }
				showParents={ showParents }
				useApiNames={ false } />
		,
		[ parentIndex, showParents ]
	);

	return (
		<SelectionTable
			dataSource={ resource }
			forceShowSelection={ resourceIdsUri ? undefined : false }
			loading={ loading }
			renderRow={ renderField }
			rowKey={ getRowKey }
			selectionData={ selectionData }
			selectionType={ PERISCOPE_TAB_TYPES.FIELDS } />
	);
};
